export default __webpack_public_path__ + "static/media/ThreeDotIcon.ea85c632.svg";